import Vue from 'vue';
import Vuex, { ActionTree, MutationTree } from 'vuex';
import { notificationWebservice } from '@/webservices/notification';

Vue.use(Vuex);

interface State {
    count: number;
}

const mutations: MutationTree<State> = {
    setCount(currentState, count: number) {
        currentState.count = count;
    },

    resetState() {
        // console.log('resetState FIRED FROM Account STORE');
        // acquire initial state
        const s = initialState();

        Object.keys(s).forEach((key) => {
            state[key] = s[key];
        });
    },
};

const actions: ActionTree<State, any> = {
    fetchCount({ commit }): any {
        notificationWebservice.count().then((response) => {
            if (response && response.data !== undefined) {
                commit('setCount', response.data);
            }
        });
    },
};

const getters = {
    count(currentState: State): number {
        return currentState.count;
    },
};

function initialState() {
    return {
        count: 0,
    };
}

const state: State = initialState();

const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};

export default module;
